import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Header from './components/Header';
import Sidebar from './components/Sidebar';

import classNames from 'classnames';

const AdminLayout = () => {
  let isMd = useMediaQuery({ query: '(max-width: 1023px)' });

  const [isOpenSidebar, setIsOpenSidebar] = useState(isMd ? false : true);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (isMd) {
      setIsOpenSidebar(false);
    } else {
      setIsOpenSidebar(true);
    }
  }, [isMd]);

  return (
    <>
      <Sidebar
        isOpenSidebar={isOpenSidebar}
        setIsOpenSidebar={setIsOpenSidebar}
        darkMode={darkMode}
      />
      <div
        className={classNames({
          'flex flex-col flex-1 bg-slate-200  min-h-screen text-slate-600 ': true,
          'md:pl-64': isOpenSidebar === true,
          'md:pl-0': isOpenSidebar === false,
        })}
      >
        <Header
          setIsOpenSidebar={setIsOpenSidebar}
          isOpenSidebar={isOpenSidebar}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
        />
        <Outlet />
      </div>
    </>
  );
};

export default AdminLayout;
